import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { TutorBillingStore } from './interfaces'
import type { TutorBillingModal } from '../enums'

import { isFullArray } from '@shared/lib/collections'

const isModal = (state: TutorBillingStore) => (modal: TutorBillingModal): boolean => state.modal === modal

const isModalFor = (state: TutorBillingStore) => (modal: TutorBillingModal, rowId: number | null): boolean =>
  state.modal === modal && (state.activeRow?.id ?? null) === rowId

export const getters = {
  isLoading: (state: TutorBillingStore): TutorBillingStore['loading'] => state.loading,
  isSaving: (state: TutorBillingStore): TutorBillingStore['saving'] => state.saving,
  getRows: (state: TutorBillingStore): TutorBillingStore['rows'] => state.rows,
  hasRows: (state: TutorBillingStore): boolean => isFullArray(state.rows),
  getMeta: (state: TutorBillingStore): Meta | null => state.meta,
  getFilters: (state: TutorBillingStore): TutorBillingStore['filters'] => state.filters,
  getCurrentPage: (state: TutorBillingStore): TutorBillingStore['currentPage'] => state.currentPage,
  getPerPage: (state: TutorBillingStore): TutorBillingStore['perPage'] => state.perPage,
  getSelectedIds: (state: TutorBillingStore): TutorBillingStore['selectedIds'] => state.selectedIds,
  hasSelection: (state: TutorBillingStore): boolean => state.selectedIds.length > 0,
  getActiveRow: (state: TutorBillingStore): TutorBillingStore['activeRow'] => state.activeRow,
  isModal: (state: TutorBillingStore): ((modal: TutorBillingModal) => boolean) => isModal(state),
  isModalFor: (state: TutorBillingStore): ((modal: TutorBillingModal, rowId: number | null) => boolean) => isModalFor(state),
  getExportType: (state: TutorBillingStore): TutorBillingStore['exportType'] => state.exportType,
}
